export default __webpack_public_path__ + "static/media/blindBox.9e4675fb.jpg";